<template>
  <div id="app-loating">
    <div class="floatingBox">
      <ul>
        <li
          class="iconfont"
          style="position:relative"
          @mouseover="changeActive(1)"
          @mouseout="removeActive(-1)"
          v-if="webInfo.wapsite_url"
        >
          <i class="el-icon-mobile-phone"></i>
          <div class="img-box" v-show="pStyle==1" style="position:absolute;right:65px;top:-150px">
            <span style="color:#c30d23;font-size:20px">微信扫一扫，进入手机端</span>
            <div id="qrcode" ref="qrcode"></div>
          </div>
        </li>

        <li
          v-if="webInfo.ifdonation == 1"
          class="iconfont"
          style="font-size: 30px; font-weight: 500;"
          @mouseover="changeActive(2)"
          @mouseout="removeActive(-1)"
          @click="goDonate"
        >
          &#xe62a;
          <p :class="{active:pStyle==2}">{{pText}}</p>
        </li>
        <li
          v-if="webInfo.ifapply == 1"
          class="iconfont"
          @mouseover="changeActive(3)"
          @mouseout="removeActive(-1)"
          @click="goApply"
        >
          &#xe62e;
          <span :class="{active:pStyle==3}">{{pText1}}</span>
        </li>

        <li class="iconfont" @click="backTop()">&#xe721;</li>
      </ul>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  components: {
    QRCode
  },
  data() {
    return {
      pStyle: -1,
      pText: "",
      webInfo: {},
      pText1: ""
    };
  },
  computed: {
    webData() {
      let info = this.$store.state.web_info;
      return info;
    }
  },
  watch: {
    webData: {
      handler(val) {
        if (val) {
          this.webInfo = val;
          setTimeout(() => {
            this.getQrCode();
          }, 100);
        }
      },
      immediate: true
    }
  },
  methods: {
    getQrCode() {
      //生成二维码
      new QRCode("qrcode", {
        width: 250, // 二维码宽度
        height: 250, // 二维码高度
        text: this.webInfo.wapsite_url
      });
    },
    goDonate() {
      if (this.webInfo.donation_url) {
        window.open(this.webInfo.donation_url);
      }
    },
    goApply() {
      this.$router.push({ name: "applyIndex" });
    },
    changeActive(id) {
      this.pStyle = id;
      if (id == 1) {
      }
      if (id == 2) {
        this.pText = "我要捐赠";
      }
      if (id == 3) {
        this.pText1 = "申请救助";
      }
    },
    removeActive(id) {
      this.pStyle = id;
      this.pText = "";
      this.pText1 = "";
    },
    backTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.floatingBox {
  position: fixed;
  right: 20px;
  top: 60%;
  z-index: 9999;
  > ul {
    > li {
      list-style: none;
      width: 58px;
      height: 59px;
      // background-color: #c30d23;
      border: solid 1px #ddd;
      text-align: center;
      line-height: 59px;
      color: #999;
      font-size: 26px;
      cursor: pointer;
      border-top: none;
      // transition: all 0.4s ease;
      &:first-child {
        height: 58px;
        border-top: solid 1px #ddd;
        .img-box {
          > img {
            width: 0px;
            height: 250px;
            transition: all 0.4s ease;
            word-break: keep-all;
          }
        }
        &:hover {
          .img-box {
            > img {
              width: 250px;
            }
          }
        }
      }
      &:hover {
        background-color: #c30d23;
        border-color: #c30d23;
        color: #fff;
      }
      > p {
        position: absolute;
        top: 60px;
        right: 60px;
        width: 0;
        height: 60px;
        background-color: #ad081c;
        color: #ffffff;
        font-size: 16px;
        line-height: 59px;
        text-align: center;
        transition: all 0.4s ease;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &.active {
          width: 100px;
        }
      }
      > span {
        position: absolute;
        // top: 60px;
        right: 60px;
        width: 0;
        height: 60px;
        background-color: #ad081c;
        color: #ffffff;
        font-size: 16px;
        line-height: 59px;
        text-align: center;
        transition: all 0.4s ease;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &.active {
          width: 100px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/floatingButton.vue